import { Button } from '@mui/material';
import FilterListIcon from '@mui/icons-material/FilterList';

interface UserAdminFiltersProps {
  onOpenFilters: () => void;
  activeFilterCount: number;
}

const UserAdminFilters = ({
  onOpenFilters,
  activeFilterCount,
}: UserAdminFiltersProps) => {
  return (
    <Button
      startIcon={<FilterListIcon />}
      variant="outlined"
      onClick={onOpenFilters}
      sx={{
        flexShrink: 0,
        whiteSpace: 'nowrap',
        ml: 2,
        height: '40px',
      }}
    >
      Filters {activeFilterCount > 0 ? `(${activeFilterCount})` : ''}
    </Button>
  );
};

export default UserAdminFilters;
